import DividerRoot, { Props } from './Divider'

export default function Divider(props: Props) {
  return <DividerRoot {...props} />
}

export type { Props as DividerProps }
